import { Component, OnInit } from '@angular/core';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { ICompany } from 'src/app/interfaces/company';
import { ErrorsService } from 'src/app/services/common/errors.service';
//import * as moment from "jalali-moment";

import { IConfirm } from 'src/app/interfaces/confirm';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { IBranch } from 'src/app/interfaces/branch';
import { MarkManagementService } from 'src/app/services/http/business/markManagement/mark-management.service';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { MarkTypeListComponent } from '../mark-type-list/mark-type-list.component';
import { MarkClassificationTypeEntryComponent } from '../mark-classification-type-entry/mark-classification-type-entry.component';

@Component({
  selector: 'app-mark-classification-type-list',
  templateUrl: './mark-classification-type-list.component.html',
  styleUrls: ['./mark-classification-type-list.component.css']
})
export class MarkClassificationTypeListComponent implements OnInit {

  param: any;
  errObject: any;
  isOwner: boolean;
  errors = new Array();
  pageSize: number;
  pageIndex: number;
  companyList: ICompany;
  branchList: IBranch;
  companySelected: String;
  CompanyEncryptId: string;
  filter: any;
  displayedColumns: string[] = [
    "order",
    "title",
    "code",
    'function'
  ];
  dataSource = new MatTableDataSource();

  constructor(
    private dialog: MatDialog,
    public translate: TranslateService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    private markManagementService: MarkManagementService,
  ) { }

  ngOnInit() {
    this.refresh();
  }

  // get list mark-type
  refresh() {
    this.markManagementService.catList().subscribe(res => {
     
      console.log(res);

      this.dataSource = res;

    });
  }

  getColor(e) {
    switch (e.IsActive) {
      case true:
        return "custom-chips primary";
      case false:
        return "custom-chips accent";
    }
  }
  
  // create mark-type 
  add() {
    this.dialog.open(MarkClassificationTypeEntryComponent,
      {
         disableClose: true 
      })
      .afterClosed()
      .subscribe(() => {
        this.refresh();
      });
  }

  // update mark-type 
  edit(param: any) {
   
    this.dialog.open(MarkClassificationTypeEntryComponent, {
      data: param,
      disableClose: true
    })
      .afterClosed().subscribe(() => {
        this.refresh();
      });
  }

  // list mark-type 
  listMarkType(param: any) {
   
    this.dialog.open(MarkTypeListComponent, {
      data: param,
      disableClose: true,
      width: "700px",
    })
      .afterClosed().subscribe(() => {
        this.refresh();
      });
  }

  delete(data: any) {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.cancel", {
        name: this.translate.get("label.category")
      }),
      alert:null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog.open(ConfirmComponent, {
      width: "300px",
      data: confirm
    })
      .afterClosed()
      .subscribe(
        res => {
          if (res) {
            this.markManagementService.delete({ Id: data.Id }).subscribe(() => {
             
              this.snackBar.OpenSnackBar(
                this.translate.get("success.delete"),
                "ok",
                5000,
                SoundEnum.beep
              );
              this.refresh();
            }, () => {

              this.snackBar.OpenSnackBar(
                this.translate.get("error.delete"),
                "ok",
                5000,
                SoundEnum.beep
              );

            });
          }
        },
        err => {
          this.errorService.recordHasBennUsed(err);
        }
      );
  }
}
